import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const fetchData = async (url, method, body, customHeaders = {}) => {
  let axiosConfig = {
    method: method,
    url: url,
    data: body,
    headers: {
      'Content-Type': 'application/json',
      ...customHeaders,
    },
  };

  const result = await axios(axiosConfig);
  return result;
};

export const handleToaster = (status, phrase) => {
  const toasterConfig = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: false,
    newestOnTop: true,
    limit: 3,
  };

  if (status === 'success') {
    toast.success(`${phrase}`, toasterConfig);
  } else if (status === 'error') {
    toast.error(`${phrase}!`, toasterConfig);
  }
  if (status === 'warning') {
    toast.warning(`${phrase}`, toasterConfig);
  }
  if (status === 'info') {
    toast.info(`${phrase}`, toasterConfig);
  }
};

export const getLocation = async () => {
  try {
    const res = await axios.get('http://ip-api.com/json');

    if (res.status === 200) {
      return res?.data?.countryCode;
    } else {
      const fallbackRes = await axios.get(
        'https://get.geojs.io/v1/ip/geo.json'
      );

      if (fallbackRes.status === 200) {
        return fallbackRes?.data?.country_code;
      } else {
        console.log('Failed to fetch location data from geojs.io');
        return null;
      }
    }
  } catch (error) {
    try {
      const fallbackRes = await axios.get(
        'https://get.geojs.io/v1/ip/geo.json'
      );

      if (fallbackRes.status === 200) {
        return fallbackRes?.data?.country_code;
      } else {
        console.log('Failed to fetch location data from geojs.io');
        return null;
      }
    } catch (fallbackError) {
      console.log('Error fetching user country from geojs.io:', fallbackError);
      return null;
    }
  }
};

export const formatPriceFromCents = (cents) => {
  if (cents === null || cents === undefined || isNaN(cents)) return '0.00';
  const dollars = parseFloat(cents) / 100;
  return dollars.toFixed(2);
};

export const formatToUTC = (input) => {
  if (!input) return 'Not Available';
  let d = null;
  try {
    if (
      typeof input === 'object' &&
      input !== null &&
      typeof input.toDate === 'function'
    ) {
      // Firestore Timestamp
      d = input.toDate();
    } else {
      d = new Date(input);
    }
  } catch (e) {
    return 'Not Available';
  }

  if (!d || isNaN(d.getTime())) return 'Not Available';

  const pad = (n) => String(n).padStart(2, '0');
  // Format: YYYY-MM-DD HH:MM:SS UTC
  // Format: YYYY-MM-DD HH:MM UTC (no seconds)
  return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(
    d.getUTCDate()
  )} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`;
};

// Format datetime to user's local timezone
export const formatToLocalTime = (input) => {
  if (!input) return 'Not Available';
  let d = null;
  try {
    if (
      typeof input === 'object' &&
      input !== null &&
      typeof input.toDate === 'function'
    ) {
      // Firestore Timestamp
      d = input.toDate();
    } else {
      d = new Date(input);
    }
  } catch (e) {
    return 'Not Available';
  }

  if (!d || isNaN(d.getTime())) return 'Not Available';

  // Format in user's local timezone with readable format
  try {
    return d.toLocaleString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  } catch (e) {
    // Fallback to basic local string if toLocaleString fails
    return d.toLocaleString();
  }
};
